import React from "react"
import { RadioGroup } from "@material-ui/core"

interface IProps {
  input: {
    onChange: (value: string) => {}
    value: string
    onBlur: (value: string) => {}
  }
  meta: { touched: boolean; error: string }
  onChange: (value: string) => {}
  onBlur?: (value: string) => {}
  name: string
}

const MuiRadioButtonGroup = (props: IProps) => {
  const {
    input: { onChange, onBlur, value, ...inputProps },
    meta,
    onChange: onChangeFromField,
    onBlur: onBlurFromField,
    ...rest
  } = props

  return (
    <RadioGroup
      {...inputProps}
      {...rest}
      value={value}
      onChange={(_event, onChangeValue) => {
        onChange(onChangeValue)
        if (onChangeFromField) {
          onChangeFromField(onChangeValue)
        }
      }}
      onBlur={() => onBlur(value)}
    />
  )
}

export default MuiRadioButtonGroup
